import { http, objToFormData } from '~~core';

import { legacyPreviewSchema, documentShowResponseSchema, documentListResponseSchema, rubricatesSchema, documentSummariesSchema } from '../schemas/document';

type RubricateParam = {
  rubricate: {
    initials?: string | null;
    manuscript?: Blob | null;
  }
};

export async function fetchDocument(signatureRequestKey: string, documentKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/documents/${documentKey}`);

  return documentShowResponseSchema.parse(data).document;
}

export async function fetchDocumentList(signatureRequestKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/documents`);

  return documentListResponseSchema.parse(data).documents;
}

export async function generateDocumentLegacyPreview(signatureRequestKey: string, documentKey: string) {
  await http(`/notarial/widget/signatures/${signatureRequestKey}/documents/${documentKey}/previews`, {
    method: 'POST',
    query: {
      notarial_key: signatureRequestKey,
    },
  });
}

export async function fetchDocumentLegacyPreview(signatureRequestKey: string, documentKey: string) {
  const { _data: data, status } = await http.raw(`/notarial/widget/signatures/${signatureRequestKey}/documents/${documentKey}/previews`);

  return {
    status,
    pages: status === 202 ? [] : legacyPreviewSchema.parse(data).pages,
  };
}

export async function fetchRubricates(signatureRequestKey: string, type?: 'initials' | 'manuscript' | 'both') {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/rubricate`, {
    query: { type },
  });

  return rubricatesSchema.parse(data).rubricate;
}

export async function saveRubricates(signatureRequestKey: string, rubricates: RubricateParam) {
  const body = objToFormData(rubricates);

  await http(`/notarial/widget/signatures/${signatureRequestKey}/rubricate`, { method: 'POST', body });
}

export async function fetchDocumentSummaries(signatureRequestKey: string, documentKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/documents/${documentKey}/summaries`, { method: 'POST' });

  return documentSummariesSchema.parse(data).summary;
}
